import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Link } from 'react-router'

// Components
import Header from '../../shared/components/Header'
// import CarRental from '../CarRental'
import CarRentalOverview from '../CarRentalOverview'

// Elements
import TabItem from '../../shared/elements/tabItem'

import { translation } from '../../utils/helpers'
import { hasAccess, hasSubscriptionPermission } from '../../utils/auth'

// Import styles
import './carRentals.scss'
import TabBar from '../../shared/elements/tabBar'
import Button from '../../shared/elements/button'
import { openOverlay } from '../../actions/common'
import OrderCapacityOverview from '../../shared/overlays/OrderCapacityOverview'

class CarRentals extends Component {

  constructor (props) {
    super(props)
    this.state = {
      tabActive: 'overview'
    }

    this.renderTabContent = this.renderTabContent.bind(this)
    this.renderTitle = this.renderTitle.bind(this)
    this.renderTitles = this.renderTitles.bind(this)
    this.renderCapacityOverview = this.renderCapacityOverview.bind(this)
  }

  componentDidMount () {
    this.checkOpenCapacityOverview()
  }

  checkOpenCapacityOverview () {
    let routeItems = window.LocalstorageStack.all()
    let index = routeItems.length - 3
    if (routeItems && routeItems.length > 3 && routeItems[index].pathname === 'OrderCapacityOverview') {
      this.props.openOverlay('OrderCapacityOverview')
    }
  }

  changeTab (title, e) {
    e.preventDefault()
    this.setState({
      tabActive: title.val
    })
  }

  renderTitle (title, index) {
    let activeClass = (this.state.tabActive === title.val ? 'active' : '')
    let onClick = this.changeTab.bind(this, title)
    let link = '#'
    if (title.link) {
      link = title.link
      onClick = () => { }
    }
    return (
      <TabItem key={'tab_' + index}>
        <Link
          className={activeClass}
          to={link}
          onClick={onClick}
          key={index}>
          {title.name}
        </Link>
      </TabItem>
    )
  }

  renderTitles () {
    let titles = [
      { name: translation('15106'), val: 'overview' } // , link: '/CarRentalOverview' }
    ]
    if (hasSubscriptionPermission(this.props.auth, 10, [11])) {
      titles.push(
        { name: translation('14778'), val: 'carRental', link: '/CarRental' }
      )
    }
    return titles.map(this.renderTitle)
  }

  renderTabContent () {
    // let titles = [
    //   { name: translation('15106'), val: 'overview' } // , link: '/CarRentalOverview' }
    // ]
    // if (hasSubscriptionPermission(this.props.auth, 10, [11])) {
    //   titles.push(
    //     { name: translation('14778'), val: 'carRental', link: '/CarRental' }
    //   )
    // }
    // const renderTitles = () => {
    //   return titles.map(this.renderTitle)
    // }
    switch (this.state.tabActive) {
      case 'carRental':
        // return <CarRental renderTitles={renderTitles()} />
        break
      case 'overview':
      default:
        return <CarRentalOverview router={this.props.router} /* renderTitles={this.renderTitles()} */ />
    }
  }

  renderCapacityOverview () {
    if (!hasAccess([3, 5, 7], this.props.auth.user.UserType) || !hasSubscriptionPermission(this.props.auth, 30) || this.props.auth.departmentType !== 1) return null
    return (
      <div className='capacity-overview hide-from-resposive'>
        <Button spacing={0} size='m' style='link' labelText={translation('17912')} onClick={() => this.props.openOverlay('OrderCapacityOverview')} />
      </div>
    )
  }

  render () {
    // let title = this.state.tabActive === 'carRental' ? translation('14778') : translation('15105')
    return (
      <div className='carrentals__screen'>
        <Header router={this.props.router} renderRight={this.renderCapacityOverview} >
          <TabBar>
            {this.renderTitles()}
          </TabBar>
        </Header>
        <div className='carrentals__screen--inner'>
          {this.renderTabContent()}
        </div>
        <OrderCapacityOverview />
      </div>
    )
  }
}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  openOverlay
})(CarRentals)



// WEBPACK FOOTER //
// ./src/app/pages/CarRentals/index.js